import { FileInputType, FileType } from "operations/schema/schema";
import { FC, useMemo } from "react";
import { RenderPdfPreview } from "./RenderPdfPreview";

interface RenderFilePreviewProps {
  file: FileType | FileInputType | null;
}

export const RenderFilePreview: FC<RenderFilePreviewProps> = (props) => {
  const { file } = props;

  const extension = useMemo(() => {
    if (!file) return "";
    // eslint-disable-next-line
    const [_, ext] = file.name?.split(".");
    return ext || "jpeg";
  }, [file]);

  if (!file) return <></>;

  if (["png", "jpg", "jpeg", "bmp", "gif", "tif", "tiff"].includes(extension)) {
    const data = file.data?.startsWith("data:image/")
      ? file.data
      : `data:image/${extension};base64,${file.data}`;

    return <img src={data} alt={file?.name} />;
  } else if (["mp4", "ogg", "webm"].includes(extension)) {
    const data = file.data?.startsWith("data:video/")
      ? file.data
      : `data:video/${extension};base64,${file.data}`;

    return <video src={data} title={file?.name} controls />;
  } else if (extension === "pdf") {
    return <RenderPdfPreview data={file.data} />;
  } else {
    return <></>;
  }
};
